/* eslint-disable func-names */
window.onload = function () {
	const instaEmbed = document.querySelectorAll('.instagram-media-rendered');
	if (instaEmbed !== null) {
		instaEmbed.forEach((item) => {
			if (!item.hasAttribute('title')) {
				item.setAttribute('title', 'Instagram post');
			}
		});
	}
};
